import regex from '../regex/regex';

export default function stripHtmlFromString(html = '', keepLineBreaks?: boolean): string {
  if (typeof document === 'undefined') {
    return html.replace(regex.stripHtmlTags, '');
  }

  const element = document.createElement('div');

  element.innerHTML = keepLineBreaks ? html.replace(/<\/p>/g, '\n') : html;

  return element.textContent || element.innerText || '';
}
